<template>
  <div class="equipment-detail container">
    <!-- 设备title、设备ID、所在省份、所在市区、围观次数、备注 -->
    <div class="header-view">
      <el-image class="info-img" fit="cover" :src="equipmentUrl" :preview-src-list="[equipmentUrl]" lazy></el-image>
      <div class="info-right">
        <div class="info-title">{{ equipmentDetail.title }}</div>
        <div class="info-tag">
          <p v-for="item in equipmentDetail.targerList" :key="item">{{ item }}</p>
        </div>
        <div class="info-use">
          <div class="use-item">
            <p>设备ID</p>
            <span>{{ equipmentDetail.id }}</span>
          </div>
          <div class="use-item">
            <p>所在市区</p>
            <span>{{ equipmentDetail.cityName }}</span>
          </div>
          <div class="use-item">
            <p>所在省份</p>
            <span>{{ equipmentDetail.provinceName }}</span>
          </div>
          <div class="use-item">
            <p>围观次数</p>
            <span>{{ equipmentDetail.pv }}</span>
          </div>
        </div>
        <div class="info-care">备注：{{ equipmentDetail.remark || "暂无备注说明" }}</div>
      </div>
    </div>
    <!-- 基本信息 -->
    <div class="base-view">
      <div class="view-title">基本信息</div>
      <div class="archives-list">
        <div class="list-item" v-for="item in baseInfo.attrs" :key="item.title" v-show="item.subType != 20203">
          <p>{{ item.title }}</p>
          <span>{{ item.tempValue || "--" }}</span>
        </div>
      </div>
    </div>
    <!-- 设备图片 -->
    <div class="pic-video-view" v-for="item in photoList" :key="item.cardTitle">
      <div class="view-title">{{ item.cardTitle }}</div>
      <div class="basic-info-content" style="padding-bottom: 0">
        <div class="photo-list">
          <div class="photo-item" v-for="(itemNew, index) in item.attrs" :key="index">
            <el-image class="img-url" fit="cover" :src="itemNew.map.thumbUrl" :preview-src-list="[itemNew.map.url]" lazy />
            <p class="photo-info">{{ itemNew.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 设备视频 -->
    <div class="pic-video-view" v-if="videoList.length > 0">
      <div class="view-title">设备视频</div>
      <div class="basic-info-content">
        <div class="photo-list">
          <div class="photo-item" v-for="(item, index) in videoList" :key="index">
            <vueMiniPlayer ref="vueMiniPlayer" :video="item" :mutex="true" @fullscreen="handleFullscreen" />
          </div>
        </div>
      </div>
    </div>
    <!-- 设备推荐 -->
    <div class="view-title" style="margin-top: 30px" v-if="recommendList.length > 0">好车推荐</div>
    <section class="recommend-list" v-if="recommendList.length > 0">
      <div class="equipment-item" v-for="(item, index) in recommendList" :key="index" @click="toEquipmentDetail(item.crmEquipmentId)">
        <el-image class="info-img" fit="cover" :src="item.thumbnail" lazy></el-image>
        <div class="info-bottom">
          <div class="info-title">{{ item.title }}</div>
          <div class="info-year">{{ item.subHeading }}</div>
          <div class="info-tag">
            <p v-for="val in item.targerList" :key="val">{{ val }}</p>
          </div>
          <div class="info-price">
            <div class="priceContent" v-if="item.crmEquipmentFixedPriceId && item.offlineBargaining != 1">
              <p>{{ item.startingPrice / 1000000 }}</p>
              <p>万</p>
            </div>
            <p style="font-size: 16px" v-else>价格面议</p>
            <img class="qrCode" fit="cover" src="@/assets/img/ewm2.png" @click.stop="showQRCode(item.crmEquipmentId, item.crmEquipmentFixedPriceId)" />
          </div>
        </div>
      </div>
    </section>
    <!-- 侧边栏服务 -->
    <Dangling />
	<el-dialog width="321px" :visible.sync="dialogVisible" @close="closeDialog">
		<div class="dialogContent">
			<el-image fit="contain" class="qrCodeImg" v-loading="paintLoading" :src="qrcodeUrl" />
		</div>
	  <div class="qrCodeText">扫描二维码手机查看该设备的详情<br />更多在售设备等待您的到来~</div>
	</el-dialog>
  </div>
</template>

<script>
import Dangling from "@/components/Dangling";
export default {
  name: "EquipmentDetail",
  components: { Dangling },
  data() {
    return {
      equipmentDetail: {}, //设备详情
      equipmentUrl: "", //设备url
      baseInfo: {}, //基础信息
      photoList: [], //设备照片
      videoList: [], //设备视频
      recommendList: [], //设备列表
      // 小程序二维码弹层展示控制参数
      dialogVisible: false,
      paintLoading: false,
      qrcodeUrl: "", //小程序码
    };
  },
  props: {},
  computed: {},
  watch: {
    $route(to, from) {
      if (to.path == "/home/equipment-detail") {
        let id = to.query.id;
        this.getEquipmentDetail(id);
        this.getEquipmentList(id);
      }
    },
  },
  async mounted() {
    let id = this.$route.query.id;
    this.getEquipmentDetail(id);
    this.getEquipmentList(id);
    sessionStorage.setItem("msgInfo", true);
  },
  methods: {
    handleFullscreen(data) {
      console.log("data", data);
    },
    async getEquipmentDetail(id) {
      try {
        let res = await this.$api.equipmentDetail({ id });
        let detail = res.data;
        detail["targerList"] = this.$optionsData.parseLabel(detail);
        this.equipmentDetail = detail;
        let cardList = detail.equipmentDetailsConfig.cardList;
        this.baseInfo = cardList.filter((v) => v.type == 202)[0]; //基本信息
        this.photoList = cardList.filter((v) => v.type == 204); //设备照片
        this.equipmentUrl = this.photoList.length ? this.photoList[0].attrs[0].map.url : "";
        let videoInfo = cardList.filter((v) => v.type == 205)[0]; //设备视频
        let videoList = [];
        videoInfo &&
          videoInfo.attrs.map((item) => {
            let b = {
              url: item.map.originVideo,
              cover: "",
              muted: false,
              loop: false,
              preload: "auto",
              poster: "",
              autoplay: false,
              playsinline: false,
              logo: "SANY",
              format: item.format,
              title: item.title,
            };
            videoList.push(b);
          });
        this.videoList = videoList;
        this.baseInfo.attrs.map((item) => {
          if (item.subType === 20201) {
            if (Object.values(item.map)[0] != "-1" && Object.values(item.map)[0] != "0" && Object.values(item.map)[0]) {
              item["tempValue"] = Object.values(item.map)[0] + item.placeholder.split("{0}")[1];
            } else {
              if (Object.values(item.map)[0] == null || Object.values(item.map)[0] == "") {
                item["tempValue"] = "";
              } else {
                item["tempValue"] = "不详";
              }
            }
          }
          if (item.subType === 20202) {
            let key = Object.values(item.map)[0];
            item.options.forEach((one) => {
              if (one.value === key) {
                item["tempValue"] = one.name;
              }
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getEquipmentList(id) {
      try {
        let res = await this.$api.equipmentRecommend({ equipmentId: id, limit: 8 });
        let list = res.data;
        list.map((item) => {
          let targerList = this.$optionsData.parseLabel(item);
          targerList = targerList.splice(0, 2);
          item["targerList"] = targerList;
          return item;
        });
        this.recommendList = list;
      } catch (error) {
        console.log(error);
      }
    },
    toEquipmentDetail(id) {
      this.$router.push(`/home/equipment-detail?id=${id}`);
    },
    async showQRCode(id, crmEquipmentFixedPriceId) {
      event.stopPropagation();
      this.paintLoading = true;
      this.qrcodeUrl = "";
      let res = await this.$api.getPosterInfo({ equipmentId: id }); //获取生成海报信息
      this.qrCode(id, res.data.auctionInfo, crmEquipmentFixedPriceId);
    },
    async qrCode(id, auctionInfo, priceId) {
      let params = {};
      if (priceId) {
        params = {
          appId: "wx4b0ed890669a0359",
          page: "pages/priceDetail/index",
          scene: `${id};${priceId};false`,
          url: "sfile-yl.sany.com.cn", //"sfile-yltest.sany.com.cn"、"sfile-yl.sany.com.cn"
          width: "96",
          // env_version: "trial",
        };
      } else {
        params = {
          appId: "wx4b0ed890669a0359",
          page: "pages/equipmentDetail/index",
          scene: auctionInfo ? `${id};true` : `${id};false`,
          url: "sfile-yl.sany.com.cn", //"sfile-yltest.sany.com.cn"、"sfile-yl.sany.com.cn"
          width: "96",
          // env_version: "trial",
        };
      }
      let resCode = await this.$api.getVxCode({ ...params }); //获取微信小程序二维码
      this.qrcodeUrl = resCode.data;
      this.dialogVisible = true;
      this.paintLoading = false;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.paintLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.equipment-detail {
  display: flex;
  flex-direction: column;
  padding-top: 30px;
  .header-view {
    display: flex;
    justify-content: space-between;
    .info-img {
      width: 610px;
      height: 400px;
    }
    .info-right {
      width: 550px;
      height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .info-title {
        font-size: 22px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
      .info-tag {
        display: flex;
        align-items: center;
        p {
          height: 18px;
          line-height: 18px;
          padding: 2px 5px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 400;
          color: #fb463f;
          background: rgba(251, 70, 63, 0.08);
          margin-right: 5px;
        }
      }
      .info-use {
        width: 550px;
        height: 96px;
        background: #f6f7f9;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        .use-item {
          width: 50%;
          display: flex;
          align-items: center;
          p {
            width: 84px;
            font-size: 16px;
            font-weight: 500;
            color: #999999;
            line-height: 18px;
          }
          span {
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            line-height: 18px;
          }
        }
      }
      .info-care {
        width: 550px;
        height: 212px;
        background: #f6f7f9;
        padding: 17px 20px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
    }
  }
  .view-title {
    font-size: 22px;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
    margin-bottom: 30px;
  }
  .base-view {
    margin-top: 60px;
    margin-bottom: 10px;
    .archives-list {
      display: flex;
      flex-wrap: wrap;
      .list-item {
        width: 33.33%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        p {
          width: 120px;
          height: 20px;
          font-size: 18px;
          font-weight: 500;
          color: #999999;
          line-height: 20px;
          flex-shrink: 0;
        }

        span {
          font-size: 18px;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .pic-video-view {
    margin-top: 30px;
    .basic-info-content {
      .info-title {
        font-size: 13px;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
        font-weight: 600;
        color: #333333;
      }
      .archives-list {
        display: flex;
        flex-wrap: wrap;
        .list-item {
          width: 33.33%;
          display: flex;
          align-items: center;
          p {
            width: 120px;
            font-size: 13px;
            color: #999;
            flex-shrink: 0;
          }
          span {
            font-size: 13px;
            font-weight: 500;
            color: #000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .photo-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .photo-item {
          width: 290px;
          height: 190px;
          margin-bottom: 30px;
          position: relative;
          .img-url {
            width: 100%;
            height: 100%;
          }
          .photo-info {
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: rgba(0, 0, 0, 0.5);
            font-size: 16px;
            font-weight: 400;
            color: #ffffff;
            position: absolute;
            left: 0;
            bottom: 0;
          }
          &:last-child:nth-child(4n - 1) {
            margin-right: calc(24% + 4% / 3);
          }
          &:last-child:nth-child(4n - 2) {
            margin-right: calc(48% + 8% / 3);
          }
        }
      }
    }
  }
  .recommend-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 100%;
    .equipment-item {
      width: 290px;
      height: 100%;
      margin-bottom: 30px;
      cursor: pointer;
      .info-img {
        width: 290px;
        height: 190px;
        display: block;
      }
      .info-bottom {
        width: 100%;
        height: 110px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        box-sizing: border-box;
        .info-title {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .info-year {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
        .info-tag {
          display: flex;
          align-items: center;
          p {
            height: 18px;
            line-height: 18px;
            padding: 2px 5px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            color: #fb463f;
            background: rgba(251, 70, 63, 0.08);
            margin-right: 5px;
          }
        }
        .info-price {
          display: flex;
		  flex-direction: row;
		  justify-content: space-between;
		  .priceContent {
			  display: flex;
			  flex-direction: row;
			  align-items: flex-end;
		  }
          p {
            color: #fb463f;
            &:nth-child(1) {
              font-weight: 500;
              font-size: 22px;
            }
            &:nth-child(2) {
              font-weight: 400;
              font-size: 14px;
              line-height: 18px;
              margin-left: 2px;
            }
          }
          .qrCode {
            height: 25px;
            width: 25px;
          }
        }
      }
      &:last-child:nth-child(4n - 1) {
        margin-right: calc(24% + 4% / 3);
      }
      &:last-child:nth-child(4n - 2) {
        margin-right: calc(48% + 8% / 3);
      }
      &:hover {
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      }
    }
  }
  .qrCodeImg {
    width: 300px;
    height: 300px;
  }
  .qrCodeText {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: 1.5;
  }
  .dialogContent {
	  width: 100%;
	  display: flex;
	  align-items: center;
	  justify-content: center;
  }
}

/deep/ .vm-player {
  min-height: 0;
  ._play-btn {
    z-index: 1;
  }
  ._logo {
    z-index: 0;
  }
  .qun-base-controls {
    z-index: 0;
  }
}
</style>
